
import { WebhookEvent, getEventIcon, getEventColor } from "./eventUtils";

interface WebhookEventRowProps {
  event: WebhookEvent;
}

export const WebhookEventRow = ({ event }: WebhookEventRowProps) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  const formatPhone = (phone: string) => {
    return phone || 'Unknown';
  };

  return (
    <tr className="hover:bg-gray-50 transition-colors duration-150">
      <td className="px-3 py-2 whitespace-nowrap">
        <div className="flex items-center">
          <span className="mr-2">{getEventIcon(event.event_type)}</span>
          <span className={`text-${getEventColor(event.event_type)}-600`}>
            {event.event_type || 'Unknown'}
          </span>
        </div>
      </td>
      <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500">
        {formatPhone(event.phone_number)}
      </td>
      <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500">
        {formatDate(event.created_at)}
      </td>
      <td className="px-3 py-2 whitespace-nowrap text-sm">
        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
          event.verified 
            ? 'bg-green-100 text-green-800' 
            : 'bg-yellow-100 text-yellow-800'
        }`}>
          {event.verified ? 'Verified' : 'Pending'}
        </span>
      </td>
    </tr>
  );
};
